import { useCallback } from "react";

export function useElementChangeEvent(callback: (value: any) => void) {
  return useCallback((e) => callback(e.target.value), [callback]);
}
